import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { DashboardPage } from "web_myplann/Dashboard/Pages/DashboardPage";
import { DashboardV2Page } from "web_myplann/Dashboard/Pages/DashboardV2Page";
import { DashboardVariantContext } from "web_myplann/Dashboard/State/dashboardVariantContext";

export const DashboardPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return (
		<DashboardVariantContext.Provider value={hasGoalsRight ? "v2" : "v1"}>
			{hasGoalsRight ? <DashboardV2Page /> : <DashboardPage />}
		</DashboardVariantContext.Provider>
	);
};
